import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConsumerTypesActions } from './consumer-types.actions';
import { ConsumerTypesSelectors } from './consumer-types.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import { State as CoreState } from '@emm/core/store/core.reducer';


export interface ConsumerTypesQueries extends AsyncActionQueries {
    all$: Observable<ConsumerType[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ConsumerTypesStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ConsumerTypesSelectors);
    }



    dispatch = {
        loadConsumerTypes: () =>
            this.store.dispatch(ConsumerTypesActions.loadAll())
    };



    queries: ConsumerTypesQueries = {
        all$: this.selectNonNil(ConsumerTypesSelectors.getValidAll),
        ...this.asyncActionQueries
    };



}
